import { unformatNumber } from './unformat-number'

export function toFloat(value: string) {
  const valueToFormat =
    parseFloat(String(Number(unformatNumber(value)) / 100)).toFixed(2) || 0
  return valueToFormat
}
